import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode, useCallback } from "react";
import { useSuspense } from "use-react-suspense";
import { ErrorCard } from "./components/error-card";
import { getAppConfig } from "./config/config";
import { ApiErrorContextProvider } from "./context/api-error-context-provider";
import { InviteAudiologistContextProvider } from "./context/invite-audiologist-context-provider";
import { useAuthContext } from "./context/use-auth-context";
import { loadi18n } from "./i18n";
import { routeTree } from "./routeTree.gen";
import { NotFoundView } from "./views/public/not-found/not-found-view";

const router = createRouter({
  routeTree,
  defaultStructuralSharing: true,
  context: { authentication: undefined! },
  trailingSlash: "never",
  defaultErrorComponent: () => (
    <ErrorCard
      sx={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    />
  ),
  defaultNotFoundComponent: NotFoundView,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export const App = () => {
  const authentication = useAuthContext();

  const loadTranslations = useCallback(async () => {
    await loadi18n(getAppConfig().language);
    return Promise.resolve(true);
  }, []);

  useSuspense(loadTranslations, []);

  return (
    <StrictMode>
      <ApiErrorContextProvider>
        <InviteAudiologistContextProvider>
          <RouterProvider context={{ authentication }} router={router} />
          <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
        </InviteAudiologistContextProvider>
      </ApiErrorContextProvider>
    </StrictMode>
  );
};
